import { Tabs } from "antd";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  setRefetch,
  setRefetchKey,
} from "../../../features/global/globalSlice";
import PermissionTable from "./PermissionTable";
import BreadCrumb from "../../../layout/BreadCrumb";

function ProfileViewList() {
  const { user } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const types = [
    { label: "SDI", key: "1", type: "SDI" },
    { label: "NIA", key: "2", type: "NIA" },
    { label: "NWHSA", key: "3", type: "NWHSA" },
    { label: "County", key: "4", type: "CIDU" },
    { label: "IWUA", key: "5", type: "IWUA" },
  ];

  const [active, setactive] = useState(() => {
    if (user?.userInstitution === "SDI") {
      return "1";
    } else {
      const userTypeKey = types.find((t) => t.type === user?.userInstitution)?.key;
      return userTypeKey || "1";
    }
  });

  async function refetching(activeKey) {
    setactive(activeKey);
    await dispatch(setRefetch());
    await dispatch(setRefetchKey(activeKey));
  }

  const { activeObjProfile } = useSelector((state) => ({
    activeObjProfile: state.obj.activeObj["profile"],
  }));

  const initialActiveKey =
    user?.userInstitution === "SDI"
      ? "1"
      : types?.find((t) => t?.type === user?.userInstitution)?.key || "1";

  const tabConfigurations = types?.map(({ label, key, type }) => ({
    label: <span className="flex items-center">{label}</span>,
    key,
    children: <PermissionTable type={type} tabKey={key} />,
  }));

  const filteredTabs =
    user?.userInstitution === "SDI"
      ? tabConfigurations
      : tabConfigurations?.filter((tab) => tab?.key === initialActiveKey);
 
  return (
    <div>
      <BreadCrumb
        breadcrumbs={[
          { title: "Profile", path: "/user/profile-list" },
          { title: `View ${activeObjProfile?.profProfile} Profile` },
        ]}
      />
      <div className="white_card w-full flex-1 min-h-[80vh] mt-[2.06rem]">
        <div className="form-add-h mb-[2.5rem]">All Profiles</div>
        <Tabs
          items={filteredTabs}
          // defaultActiveKey="1"
          activeKey={active}
          onChange={refetching}
          className="activity-tab-wrap permission-tab permission-bar"
        />
      </div>
    </div>
  );
}

export default ProfileViewList;
